(function () {
  if (window.__daaraaWishlistLoaded) return;
  window.__daaraaWishlistLoaded = true;

  const WISHLIST_ENDPOINT = "https://oricmeta.com/reviews-api",
    WISHLIST_PAGE_URL = "/pages/wishlist",
    isLoggedIn = !!window.wishlistCustomerId;

  let cachedItems = null;
  let itemsPromise = null;

  const HEART_SVG =
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-7-4.35-9.5-8.5C.5 8.5 3 5 6.5 5c2 0 3.5 1.5 5.5 3.5C14 6.5 15.5 5 17.5 5 21 5 23.5 8.5 21.5 12.5 19 16.65 12 21 12 21z"/></svg>',
    BAG_SVG =
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';

  function esc(str) {
    return String(str == null ? "" : str).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* ---------- storage / API ---------- */

  function getGuestItems() {
    try {
      return JSON.parse(localStorage.getItem("wishlist_guest_items") || "[]");
    } catch (e) {
      return [];
    }
  }

  function setGuestItems(items) {
    try {
      localStorage.setItem("wishlist_guest_items", JSON.stringify(items));
    } catch (e) {}
  }

  async function fetchWishlist() {
    if (isLoggedIn) {
      const res = await fetch(
        WISHLIST_ENDPOINT + "/wishlist_get.php?customer_id=" + window.wishlistCustomerId
      );
      return (await res.json()).items || [];
    }
    return getGuestItems();
  }

  // Cached as a PROMISE so parallel callers share ONE request
  function getWishlistItems() {
    if (cachedItems) return Promise.resolve(cachedItems);
    if (!itemsPromise) {
      itemsPromise = fetchWishlist()
        .then(function (items) {
          cachedItems = items;
          return items;
        })
        .catch(function (err) {
          itemsPromise = null; // allow retry
          throw err;
        });
    }
    return itemsPromise;
  }

  async function safeItems() {
    try {
      return await getWishlistItems();
    } catch (e) {
      return cachedItems || [];
    }
  }

  async function isVariantSaved(variantId) {
    return (await safeItems()).some((i) => String(i.variant_id) === String(variantId));
  }

  async function isHandleSaved(handle) {
    return (await safeItems()).some((i) => i.product_handle === handle);
  }

  async function addToWishlist(variantId, productHandle) {
    variantId = String(variantId);
    await safeItems();
    if (isLoggedIn) {
      await fetch(WISHLIST_ENDPOINT + "/wishlist_add.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          customer_id: window.wishlistCustomerId,
          variant_id: variantId
        })
      });
    } else {
      const items = getGuestItems();
      if (!items.some((i) => String(i.variant_id) === variantId)) {
        items.push({ variant_id: variantId, product_handle: productHandle });
        setGuestItems(items);
      }
    }
    cachedItems || (cachedItems = []);
    cachedItems.some((i) => String(i.variant_id) === variantId) ||
      cachedItems.push({ variant_id: variantId, product_handle: productHandle });
    updateWishlistBadge();
    document.dispatchEvent(new CustomEvent("wishlist:change"));
  }

  async function removeFromWishlist(variantId) {
    variantId = String(variantId);
    await safeItems();
    if (isLoggedIn) {
      await fetch(WISHLIST_ENDPOINT + "/wishlist_remove.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          customer_id: window.wishlistCustomerId,
          variant_id: variantId
        })
      });
    } else {
      setGuestItems(getGuestItems().filter((i) => String(i.variant_id) !== variantId));
    }
    cachedItems &&
      (cachedItems = cachedItems.filter((i) => String(i.variant_id) !== variantId));
    updateWishlistBadge();
    document.dispatchEvent(new CustomEvent("wishlist:change"));
  }

  async function removeAllVariantsForHandle(handle) {
    const toRemove = (await safeItems()).filter((i) => i.product_handle === handle);
    for (const item of toRemove) await removeFromWishlist(item.variant_id);
  }

  async function resolveDefaultVariantId(card, handle) {
    const hiddenInput = card.querySelector('input[name="id"]');
    if (hiddenInput && hiddenInput.value) return String(hiddenInput.value);
    try {
      const product = await (await fetch("/products/" + handle + ".js")).json();
      const variant =
        (product.variants || []).find((v) => v.available) || (product.variants || [])[0];
      return variant ? String(variant.id) : null;
    } catch (e) {
      return null;
    }
  }

  /* ---------- hearts on product cards ---------- */

  function findProductMedia(card) {
    const selectors = [
      ".product-card__media",
      ".product-card__media-container",
      '[class*="product-card__media"]'
    ];
    for (const selector of selectors) {
      const element = card.querySelector(selector);
      if (element) return element;
    }
    const image = card.querySelector("img");
    if (image) {
      let parent = image.parentElement;
      for (let i = 0; i < 4 && parent; i++) {
        if (parent.querySelector && parent.querySelector("img")) return parent;
        parent = parent.parentElement;
      }
    }
    return null;
  }

  // Guarantees exactly ONE heart layer per card (removes any extras)
  function ensureHeartLayer(card) {
    const layers = card.querySelectorAll(":scope > .wishlist-heart-layer");
    let layer = layers[0];
    for (let i = 1; i < layers.length; i++) layers[i].remove();
    if (!layer) {
      layer = document.createElement("div");
      layer.className = "wishlist-heart-layer";
      layer.setAttribute("aria-hidden", "true");
      card.appendChild(layer);
    }
    return layer;
  }

  // Reads ALL geometry first, then writes ALL styles (no layout thrashing).
  // LEFT / WIDTH come from CSS defaults (0px / 100% of the card).
  // Only TOP and HEIGHT are measured, and only written when they changed.
  const lastGeom = new WeakMap();

  function syncHeartLayers(cards) {
    const jobs = [];
    cards.forEach(function (card) {
      if (!card || !card.isConnected) return;
      const media = findProductMedia(card);
      const layer = card.querySelector(":scope > .wishlist-heart-layer");
      if (!media || !layer) return;
      const cardRect = card.getBoundingClientRect();
      const mediaRect = media.getBoundingClientRect();
      if (!cardRect.width || !mediaRect.height) return;

      let top = mediaRect.top - cardRect.top;
      top = Math.max(0, Math.min(top, cardRect.height));
      const height = Math.max(0, Math.min(mediaRect.height, cardRect.height - top));
      jobs.push({ layer: layer, top: Math.round(top * 10) / 10, height: Math.round(height * 10) / 10 });
    });
    jobs.forEach(function (j) {
      const prev = lastGeom.get(j.layer);
      if (!prev || prev.top !== j.top || prev.height !== j.height) {
        j.layer.style.setProperty("--wishlist-media-top", j.top + "px");
        j.layer.style.setProperty("--wishlist-media-height", j.height + "px");
        lastGeom.set(j.layer, { top: j.top, height: j.height });
      }
      j.layer.classList.contains("wishlist-synced") || j.layer.classList.add("wishlist-synced");
    });
  }

  function syncAllHeartLayers() {
    syncHeartLayers(
      Array.prototype.slice.call(
        document.querySelectorAll("product-card[data-wishlist-injected]")
      )
    );
  }

  let resizeTimer = null;
  function queueSyncAllDebounced() {
    resizeTimer && clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      requestAnimationFrame(syncAllHeartLayers);
    }, 150);
  }

  // One card re-measure (used when an image inside it finishes loading)
  const pendingCards = new Set();
  let pendingQueued = false;
  function queueSyncCard(card) {
    pendingCards.add(card);
    if (pendingQueued) return;
    pendingQueued = true;
    requestAnimationFrame(function () {
      pendingQueued = false;
      const list = Array.from(pendingCards);
      pendingCards.clear();
      syncHeartLayers(list);
    });
  }

  let resizeObserver = null;
  const mediaToCard = new WeakMap();

  function observeCard(card) {
    if (!resizeObserver) return;
    try {
      resizeObserver.observe(card);
      const media = findProductMedia(card);
      if (media) {
        mediaToCard.set(media, card);
        resizeObserver.observe(media);
      }
    } catch (e) {}
  }

  function startResizeObserver() {
    if (typeof ResizeObserver === "undefined") return;
    resizeObserver = new ResizeObserver(function (entries) {
      const cards = [];
      entries.forEach(function (entry) {
        const card = mediaToCard.get(entry.target) || entry.target;
        if (cards.indexOf(card) === -1) cards.push(card);
      });
      // Let the browser finish its layout pass first
      requestAnimationFrame(function () {
        syncHeartLayers(cards);
      });
    });
  }

  function buildHeart(card, handle, saved) {
    const heart = document.createElement("button");
    heart.type = "button";
    heart.className = "wishlist-heart-btn";
    heart.setAttribute("aria-label", "Add to wishlist");
    heart.innerHTML = HEART_SVG;
    if (saved) {
      heart.classList.add("is-wishlisted");
      heart.setAttribute("aria-label", "Remove from wishlist");
    }

    heart.addEventListener("click", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (heart.disabled) return;
      heart.disabled = true;
      try {
        if (heart.classList.contains("is-wishlisted")) {
          await removeAllVariantsForHandle(handle);
          heart.classList.remove("is-wishlisted");
          heart.setAttribute("aria-label", "Add to wishlist");
        } else {
          const variantId = await resolveDefaultVariantId(card, handle);
          if (variantId) {
            await addToWishlist(variantId, handle);
            heart.classList.add("is-wishlisted");
            heart.setAttribute("aria-label", "Remove from wishlist");
          }
        }
      } catch (error) {
        console.error("Wishlist error:", error);
      } finally {
        heart.disabled = false;
      }
    });

    return heart;
  }

  // If the theme re-rendered a card and our heart/layer is gone,
  // clear the flag so the card gets a fresh heart.
  function repairInjectedCards() {
    document
      .querySelectorAll("product-card[data-wishlist-injected]")
      .forEach(function (card) {
        if (!card.querySelector(":scope > .wishlist-heart-layer .wishlist-heart-btn")) {
          card.removeAttribute("data-wishlist-injected");
        }
      });
  }

  async function injectCards(cards) {
    // Pass 1 (sync): decide which cards get a heart and flag them immediately,
    // so overlapping calls can never double-inject.
    const todo = [];
    cards.forEach(function (card) {
      if (!card.isConnected || card.hasAttribute("data-wishlist-injected")) return;
      const link = card.querySelector(".product-card__link");
      if (!link) return;
      const match = (link.getAttribute("href") || "").match(/\/products\/([^/?]+)/);
      const handle = match ? match[1] : "";
      if (!handle) return;
      if (!findProductMedia(card)) return;
      card.setAttribute("data-wishlist-injected", "true");
      card.classList.add("wishlist-card-anchor");
      todo.push({ card: card, handle: handle });
    });
    if (!todo.length) return;

    // Load saved items ONCE for all cards
    let savedHandles = new Set();
    try {
      const items = await getWishlistItems();
      savedHandles = new Set(items.map((i) => i.product_handle));
    } catch (error) {
      console.error("Wishlist load error:", error);
    }

    // Pass 2: build DOM only (no measuring)
    const injected = [];
    todo.forEach(function (t) {
      const layer = ensureHeartLayer(t.card);
      layer.querySelectorAll(".wishlist-heart-btn").forEach(function (old) {
        old.remove();
      });
      layer.appendChild(buildHeart(t.card, t.handle, savedHandles.has(t.handle)));
      injected.push(t.card);
    });

    // Pass 3: one batched measure/write, then watch for size changes
    requestAnimationFrame(function () {
      syncHeartLayers(injected);
      injected.forEach(observeCard);
    });

    // Slideshow / images may still be settling: measure again shortly after
    setTimeout(function () {
      syncHeartLayers(injected);
    }, 400);
    setTimeout(function () {
      syncHeartLayers(injected);
      // Fallback: never leave a VISIBLE heart hidden if a measurement was skipped
      injected.forEach(function (card) {
        const layer = card.querySelector(":scope > .wishlist-heart-layer");
        if (layer && card.isConnected && card.getBoundingClientRect().width > 0) {
          layer.classList.add("wishlist-synced");
        }
      });
    }, 1200);
  }

  /* Cards are only processed when they are close to the screen
     (this is what removes the long tasks on page load). */
  let cardIO = null;

  function watchCards(root) {
    const cards = (root || document).querySelectorAll(
      "product-card:not([data-wishlist-injected]):not([data-wishlist-watch])"
    );
    if (!cards.length) return;
    if (!cardIO) {
      injectCards(Array.prototype.slice.call(cards));
      return;
    }
    cards.forEach(function (card) {
      card.setAttribute("data-wishlist-watch", "1");
      cardIO.observe(card);
    });
  }

  function startCardObserver() {
    if (typeof IntersectionObserver === "undefined") return;
    cardIO = new IntersectionObserver(
      function (entries) {
        const visible = [];
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          cardIO.unobserve(entry.target);
          entry.target.removeAttribute("data-wishlist-watch");
          visible.push(entry.target);
        });
        visible.length && injectCards(visible);
      },
      { rootMargin: "400px 300px" }
    );
  }

  // Only react when new product cards are actually added to the page
  let injectTimer = null;

  const observer = new MutationObserver(function (mutations) {
    let relevant = false;
    outer: for (const mutation of mutations) {
      for (const node of mutation.removedNodes) {
        if (
          node.nodeType === 1 &&
          node.classList &&
          node.classList.contains("wishlist-heart-layer")
        ) {
          relevant = true;
          break outer;
        }
      }
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.classList && node.classList.contains("wishlist-heart-layer")) continue;
        if (
          node.localName === "product-card" ||
          (node.firstElementChild && node.querySelector("product-card"))
        ) {
          relevant = true;
          break outer;
        }
      }
    }
    if (!relevant) return;
    injectTimer && clearTimeout(injectTimer);
    injectTimer = setTimeout(function () {
      repairInjectedCards();
      watchCards();
    }, 80);
  });

  function startWishlistObserver() {
    document.body && observer.observe(document.body, { childList: true, subtree: true });
  }

  function startGeometryListeners() {
    // An image finished loading: re-measure ONLY its own card
    document.addEventListener(
      "load",
      function (e) {
        const t = e.target;
        if (t && t.tagName === "IMG" && t.closest) {
          const card = t.closest("product-card[data-wishlist-injected]");
          card && queueSyncCard(card);
        }
      },
      true
    );
    window.addEventListener("resize", queueSyncAllDebounced, { passive: true });
    window.addEventListener("orientationchange", queueSyncAllDebounced, { passive: true });
    window.addEventListener("pageshow", queueSyncAllDebounced);
  }

  /* ---------- header icon + badge ---------- */

  function injectHeaderIcon() {
    if (window.__wishlistHeaderInjected) return;
    const actions = document.querySelector("header-actions");
    if (!actions) return;
    window.__wishlistHeaderInjected = true;

    const link = document.createElement("a");
    link.href = WISHLIST_PAGE_URL;
    link.className = "header-actions__action wishlist-header-icon";
    link.setAttribute("aria-label", "Wishlist");
    link.innerHTML =
      '<span class="svg-wrapper">' +
      HEART_SVG +
      '</span><span class="wishlist-count-badge" style="display:none;">0</span>';
    actions.appendChild(link);
    updateWishlistBadge();
  }

  async function updateWishlistBadge() {
    const badge = document.querySelector(".wishlist-count-badge");
    if (!badge) return;
    const items = await safeItems();
    if (items.length > 0) {
      badge.textContent = items.length;
      badge.style.display = "inline-flex";
    } else {
      badge.style.display = "none";
    }
  }

  /* ---------- wishlist page ---------- */

  async function addToCart(variantId) {
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        console.error("Add to cart failed", err);
        return false;
      }
      return true;
    } catch (err) {
      console.error("Add to cart request failed", err);
      return false;
    }
  }

  function formatINR(paise) {
    return (paise / 100).toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0
    });
  }

  async function buildWishlistCard(item, grid) {
    try {
      const res = await fetch("/products/" + encodeURIComponent(item.product_handle) + ".js");
      if (!res.ok) return null;
      const product = await res.json();
      const variant =
        (product.variants || []).find((v) => String(v.id) === String(item.variant_id)) ||
        (product.variants || [])[0];
      if (!variant) return null;

      const price = formatINR(variant.price);
      const compareAt =
        variant.compare_at_price > variant.price ? formatINR(variant.compare_at_price) : null;
      const image =
        (variant.featured_image && variant.featured_image.src) ||
        product.featured_image ||
        (product.images && product.images[0]) ||
        "";
      const variantLabel =
        variant.title && variant.title !== "Default Title" ? " – " + variant.title : "";
      const href = "/products/" + product.handle + "?variant=" + variant.id;

      const card = document.createElement("div");
      card.className = "wishlist-card-wrap";
      card.innerHTML =
        '<button class="wishlist-bag-btn" aria-label="Add to cart">' + BAG_SVG + "</button>" +
        '<button class="wishlist-remove-btn" aria-label="Remove from wishlist">&times;</button>' +
        '<a href="' + esc(href) + '" class="wishlist-card-image">' +
        '<img src="' + esc(image) + '" alt="' + esc(product.title) + '" loading="lazy" decoding="async"></a>' +
        '<a href="' + esc(href) + '" class="wishlist-card-title">' +
        esc(product.title + variantLabel) + "</a>" +
        '<div class="wishlist-card-price"><span class="wishlist-card-price-current">' + esc(price) + "</span>" +
        (compareAt
          ? '<span class="wishlist-card-price-compare">' + esc(compareAt) + "</span>"
          : "") +
        "</div>";

      card
        .querySelector(".wishlist-remove-btn")
        .addEventListener("click", async function (e) {
          e.preventDefault();
          await removeFromWishlist(item.variant_id);
          card.remove();
          grid.children.length || (grid.innerHTML = "<p>Your wishlist is empty.</p>");
        });

      const bagBtn = card.querySelector(".wishlist-bag-btn");
      if (variant.available) {
        bagBtn.addEventListener("click", async function (e) {
          e.preventDefault();
          bagBtn.disabled = true;
          if (await addToCart(variant.id)) {
            await removeFromWishlist(item.variant_id);
            window.location.reload();
          } else {
            bagBtn.disabled = false;
            alert("Sorry, we could not add this to your cart. Please try again.");
          }
        });
      } else {
        bagBtn.disabled = true;
        bagBtn.title = "Sold out";
        bagBtn.style.opacity = "0.4";
        bagBtn.style.cursor = "not-allowed";
      }
      return card;
    } catch (err) {
      console.error("Could not load product", item.product_handle, err);
      return null;
    }
  }

  async function renderWishlistPage() {
    const grid = document.querySelector("#wishlist-grid");
    if (!grid) return;
    grid.innerHTML = "";

    const items = await safeItems();
    if (items.length === 0) {
      grid.innerHTML = "<p>Your wishlist is empty.</p>";
      return;
    }

    // All products load IN PARALLEL (was one-by-one), order is preserved
    const cards = await Promise.all(items.map((item) => buildWishlistCard(item, grid)));
    const frag = document.createDocumentFragment();
    cards.forEach((c) => c && frag.appendChild(c));
    grid.appendChild(frag);
    grid.children.length || (grid.innerHTML = "<p>Your wishlist is empty.</p>");
  }

  /* ---------- init ---------- */

  function initWishlist() {
    startResizeObserver();
    startCardObserver();
    startGeometryListeners();
    injectHeaderIcon();
    watchCards();
    renderWishlistPage();
    startWishlistObserver();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initWishlist);
  } else {
    initWishlist();
  }

  window.DaaraaWishlist = {
    add: addToWishlist,
    remove: removeFromWishlist,
    isSaved: isVariantSaved,
    isProductSaved: isHandleSaved,
    getSavedItems: getWishlistItems
  };
})();
